
export default function postServices () {

	const swiperServices = document.querySelectorAll('section.post-services .services .swiper:not(.swiper-initialized)');
	const swiperRelated = document.querySelectorAll('section.post-services .related .swiper:not(.swiper-initialized)');
	const swiperTeam = document.querySelectorAll('section.post-services .team .swiper:not(.swiper-initialized)');

	if (! swiperServices.length && ! swiperRelated.length && ! swiperTeam.length) return;



	const swiperInstances = [];

	if (swiperServices) {
		swiperServices.forEach(function (container) {
			const wrap = container.closest('.swiper-wrap');

			const swiper = new Swiper(container, {
				watchOverflow: true,
				loop: false,
				spaceBetween: 0,
				breakpoints: {
					0:    { slidesPerView: 1 },
					768:  { slidesPerView: 2 },
					1360: { slidesPerView: 3 },
				},
				pagination: {
					el: wrap.querySelector('.swiper-pagination'),
					type: 'progressbar',
				},
				navigation: {
					prevEl: wrap.querySelector('.swipe-prev'),
					nextEl: wrap.querySelector('.swipe-next'),
				},
				observer: true,
				observeParents: true,
				on: {
					init: equalizeItemHeights,
					breakpoint: equalizeItemHeights,
				},
			});

			swiperInstances.push(swiper);
		});


		function getSlidesPerView() {
			const w = window.innerWidth;
			if (w >= 1360) return 3;
			if (w >= 768) return 2;
			return 1;
		}


		function equalizeItemHeights() {
			const current = getSlidesPerView();

			swiperServices.forEach(swiperEl => {
				const wrap = swiperEl.closest('.swiper-wrap');
				const layout = Number(wrap.dataset.layout);

				wrap.classList.toggle('hide', current !== layout);

				if (current !== layout) return;

				const firsts = [...swiperEl.querySelectorAll('.service:nth-child(1)')];
				const seconds = [...swiperEl.querySelectorAll('.service:nth-child(2)')];

				if (firsts.length === 0) return;

				// Important: reset before measuring
				firsts.forEach(el => el.style.height = '');
				seconds.forEach(el => el.style.height = '');

				// Since we wait for window.load, one rAF is enough
				requestAnimationFrame(() => {
					const maxFirst = Math.max(...firsts.map(el => el.scrollHeight));
					const maxSecond = Math.max(...seconds.map(el => el.scrollHeight));

					firsts.forEach(el => el.style.height = maxFirst + 'px');
					seconds.forEach(el => el.style.height = maxSecond + 'px');
				});
			});
		}

		window.addEventListener('resize', () => {
			requestAnimationFrame(equalizeItemHeights);
		});

		// Critical for first‑load: wait until assets/fonts are really ready
		window.addEventListener('load', equalizeItemHeights, { once: true });
	}



	// Init swiper - Related
	if (swiperRelated) {
		swiperRelated.forEach(function (container) {

			const wrap = container.closest('.swiper-wrap');
			new Swiper (container, {
				loop: false,
				snapToSlideEdge: true,
				breakpoints: {
					0:    { slidesPerView: 1.3, spaceBetween: 24 },
					600:  { slidesPerView: 2, spaceBetween: 36 },
					1024: { slidesPerView: 3, spaceBetween: 36 },
					1360: { slidesPerView: 4, spaceBetween: 48 },
				},
				pagination: {
					el: wrap.querySelector('.swiper-pagination'),
					type: 'progressbar',
				},
				navigation: {
					prevEl: wrap.querySelector('.swipe-prev'),
					nextEl: wrap.querySelector('.swipe-next'),
				},
			});

		});
	}



	// Init swiper - Team
	if (swiperTeam) {
		swiperTeam.forEach(function (container) {

			const wrap = container.closest('.swiper-wrap');
			new Swiper (container, {
				watchOverflow: true,
				loop: false,
				snapToSlideEdge: true,
				breakpoints: {
					0:    { slidesPerView: 1.3, spaceBetween: 24 },
					600:  { slidesPerView: 2, spaceBetween: 36 },
					1024: { slidesPerView: 3, spaceBetween: 36 },
					1360: { slidesPerView: 4, spaceBetween: 48 },
				},
				pagination: {
					el: wrap.querySelector('.swiper-pagination'),
					type: 'progressbar',
				},
				navigation: {
					prevEl: wrap.querySelector('.swipe-prev'),
					nextEl: wrap.querySelector('.swipe-next'),
				},
			});

		});
	}

}

/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on selection/attribute change) without a page
	reload, so 'DOMContentLoaded' only covers the first render - re-run init
	on every preview refresh too. ACF's block-preview JS runs in the outer
	admin window, while this script runs inside the iframe, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=post-services', postServices);
}
